import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Size } from "@repo/ui/helpers/helpers";
import { PageHeader } from "@repo/ui/Navigation/pageHeader";
import { PageWidth } from "@repo/ui/Navigation/pageWidth";
import { IconPlus } from "@tabler/icons-react";
import { type ReactNode, useState } from "react";
import { PageBody, PageLayout } from "../components/layout/pageLayout.js";
import { selectCompany } from "../features/company/companySlice.js";
import { ProjectsTable } from "../features/projects/projectsTable.js";
import { CreateTrainingModal } from "../features/projects/projectTemplates/createTrainingModal.js";
import { selectTeammate } from "../features/teammate/teammateSlice.js";
import { Can } from "../helpers/teammateAuthorizationContext.js";
import { useAppSelector } from "../hooks/hook.js";

export function TrainingsPage(): ReactNode {
  const company = useAppSelector(selectCompany);
  const teammate = useAppSelector(selectTeammate);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  if (!company || !teammate) return <></>;

  return (
    <PageLayout>
      <PageHeader
        width={PageWidth.Standard}
        title="Trainings"
        actions={
          <Can
            I={PermissionActions.CREATE}
            a={PermissionSubjects.JOB_OPENINGS}
            passThrough={true}
          >
            {(allowed) => (
              <Button
                size={Size.SMALL}
                variant={ButtonVariant.Primary}
                onClick={() => setIsCreateModalOpen(true)}
                icon={<IconPlus className="h-4 w-4" />}
                isDisabled={!allowed}
              >
                Create training
              </Button>
            )}
          </Can>
        }
      />

      <PageBody width={PageWidth.Standard}>
        <ProjectsTable filterType="training" />
      </PageBody>

      <CreateTrainingModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
    </PageLayout>
  );
}
